export default __webpack_public_path__ + "static/media/a21.20ad8fb0.jpg";